module.exports = __webpack_public_path__ + "media/6.7fb3a899.mp3";